import MaterialTable from 'material-table';
import { defaultGridOptions, useGridColDefs } from '../../utils/GridUtils';
import { makeStyles } from '@material-ui/core';
import { centeredCell } from '../../constants/StyleConstants';
import AnimatedButton from '../../components/UI/AnimatedButton';
import { useContext, useEffect, useState } from 'react';
import { LoginContext } from '../../contexts/LoginContext';
import { Fragment } from 'react';
import { CancelOutlined } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  centeredCell,
  root: {
    marginTop: '3em',
  },
  gridActions: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    marginBottom: '1em',
  },
  gridControls: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  gridButtonsWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    columnGap: '1em',
  },
  gridReference: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    columnGap: '1em',
    fontSize: '.8em',
  },
  reference: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  leftSideButton: {
    borderRadius: '1em',
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },
  rightSideButton: {
    borderRadius: '1em',
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
  activeGlow: {
    color: 'rgb(0, 255, 0)',
    boxShadow: '0px 0px 10px 0px rgb(0, 255, 0, .5)',
    borderRadius: '50%',
    margin: 0,
    stroke: 'rgb(0, 255, 0, .5)',
    strokeWidth: 4,
    strokeOpacity: 0.7,
  },
  hasNoComments: {
    color: '#BDBDBD',
  },
  sortButton: {
    '&.MuiButton-root': {
      minWidth: 'unset',
    },
    '&.MuiButton-startIcon': {
      margin: 0,
    },
  },
}));



const GridActions = ({
  selectedRows,
  setOpen,
  handleExport,
  loadingExport,
  sort,
  setSort,
  rows,

  handleDisassociate,
  reloadGrid,

  ...restProps
}) => {
  const classes = useStyles();
  const { isAllowedByRole } = useContext(LoginContext);
  const [loadingExportSelection, setLoadingExportSelection] = useState(false);
  const [loadingExportAll, setLoadingExportAll] = useState(false);

  useEffect(() => {
    !loadingExport && setLoadingExportSelection(false);
    !loadingExport && setLoadingExportAll(false);
  }, [loadingExport]);

  const disassociateEmployee = () => {
    handleDisassociate();
    //reloadGrid();
  }

return  (
  <div className={classes.gridControls}>

      <div className={classes.gridButtonsWrapper}>
        <AnimatedButton
          disabled={selectedRows.isEmpty()}
          variant="contained"
          color="secondary"
          size="small"
          startIcon={<CancelOutlined />}
          onClick={() => isAllowedByRole() && disassociateEmployee()}
          loading={loadingExportSelection}>
          Desasociar empleado
        </AnimatedButton>
       
      </div>

    </div>
  );
};

const EmployeesGrid = ({
  data,
  loading,
  tableRef,
  reloadGrid,
  selectedRows,
  setSelectedRows,
  open,
  setOpen,
  gridActions,
}) => {
  const classes = useStyles();

  const BoldValue = ({ value }) => {
    return (<b>{value}</b>);
  };
  
  const colDefs = useGridColDefs([

    { title: 'Nombre', field: 'name'},
    { title: 'Email', field: 'email', valueRender: (value, rowData) => <BoldValue value={value} />  },

  ]);

  return (
    <Fragment>
      
      <div className={classes.root}>
        <div className={classes.gridActions}>
          <GridActions selectedRows={selectedRows} loading={loading} setOpen={setOpen} rows={data} {...gridActions} />
        </div>
        <MaterialTable
          {...defaultGridOptions}
          options={{
            ...defaultGridOptions.options,
            pageSizeOptions: [...defaultGridOptions.options.pageSizeOptions, defaultGridOptions.options.pageSizeOptions.last() * 2],
            selection: true,
            headerSelectionProps: { color: 'primary'}, 
            selectionProps: rowData => {
              return {
                color: 'primary',
              };
            },
          }}
          onSelectionChange={(rows, row) => setSelectedRows(rows)}
          columns={colDefs}
          data={data}
          isLoading={loading}
          tableRef={tableRef}
        />
      </div>
    </Fragment>
  );
};

export default EmployeesGrid;